var exports = {
  "B": "BlankslateContainer__yrIQ_e",
};

module.exports = exports;
